var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3461)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_3461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9C18.2614 9 20.5 7.65685 20.5 6C20.5 4.34315 18.2614 3 15.5 3C12.7386 3 10.5 4.34315 10.5 6C10.5 7.65685 12.7386 9 15.5 9Z",
    stroke: "#16EBC3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6V10C10.5 11.657 12.739 13 15.5 13C18.261 13 20.5 11.657 20.5 10V6",
    stroke: "#16EBC3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10V14C10.5 15.657 12.739 17 15.5 17C18.261 17 20.5 15.657 20.5 14V10",
    stroke: "#16EBC3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14V18C10.5 19.657 12.739 21 15.5 21C18.261 21 20.5 19.657 20.5 18V14",
    stroke: "#16EBC3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9H5C4.60218 9 4.22064 9.15804 3.93934 9.43934C3.65804 9.72064 3.5 10.1022 3.5 10.5C3.5 10.8978 3.65804 11.2794 3.93934 11.5607C4.22064 11.842 4.60218 12 5 12H6C6.39782 12 6.77936 12.158 7.06066 12.4393C7.34196 12.7206 7.5 13.1022 7.5 13.5C7.5 13.8978 7.34196 14.2794 7.06066 14.5607C6.77936 14.842 6.39782 15 6 15H3.5",
    stroke: "#16EBC3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15V16M5.5 8V9",
    stroke: "#16EBC3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_3461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.16ce722d58199ba0b8a5be81ca8b0d14.svg";
export { ForwardRef as ReactComponent };